module.exports = {
  siteTitle: 'Saidi Tang | Software Engineer',
  siteDescription:
    "Hi, I'm Saidi! A software engineer based out of Toronto, experienced in a wide variety of technologies. Former Intern @ Zazzle, Loblaw Digital, PerkinElmer",
  siteKeywords:
    'Saidi, uwaterloo, software engineer, Google, infrastructure, developer, python, waterloo',
  siteUrl: 'https://tang.fi',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-171263006-1',
  googleVerification: '',
  name: 'Saidi Tang',
  location: 'Toronto, ON',
  email: 'saidi.tang@uwaterloo.ca',
  github: 'https://github.com/tangsaidi',
  twitterHandle: '',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/tangsaidi',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/tangsaidi',
    },
    // {
    //   name: 'Codepen',
    //   url: '',
    // },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/tangsaidi',
    }
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
    linen: '#FFF1E6',
    champagne: '#eddcd2',
    salmonPink: '#FFA69E',
    coralSea: '#B8F2E6',
    coolGrey: '#AED9E0',
    frenchGrey: '#5E6472',
    slate: '#7a7a7a',
    darkSlate: '#696969',
    darkestSlate: '#444444',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
